import { render, staticRenderFns } from "./custom-color-picker.vue?vue&type=template&id=4b1564fe&"
import script from "./custom-color-picker.vue?vue&type=script&lang=js&"
export * from "./custom-color-picker.vue?vue&type=script&lang=js&"
import style0 from "./custom-color-picker.vue?vue&type=style&index=0&id=4b1564fe&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports